import { connect } from 'react-redux';

import { Store } from 'client/common/types';

import { getSurvey } from 'client/common/store/selectors/survey';
import { replaceSurveyListItem, pushToSurveyList } from 'client/common/store/reducers/surveys';
import { showNotification } from 'client/common/store/actions/notifications';

import { sendGoals } from 'client/common/store/actions/metrika';
import {
    resumeQuicksurvey,
    archiveQuicksurvey,
    cancelQuicksurveyModeration,
    pauseQuicksurvey
} from 'client/common/store/actions/quicksurvey';
import { scrollToTop } from 'client/common/store/actions/scroll';

import I18N from 'assets/i18n/brandlift-project';

import { DispatchProps, MergedProps, OwnProps, StateProps } from './types';

import Component from './survey-item-menu';

const i18n = I18N.list.surveyList;

const mapStateToProps = (state: Store): StateProps => {
    let { boxName } = getSurvey(state);

    if (boxName === 'PRO') {
        boxName = undefined;
    }

    return {
        boxType: boxName
    };
};

const mergeProps = (
    stateProps: StateProps,
    dispatchProps: DispatchProps,
    ownProps: OwnProps
): MergedProps => {
    return {
        ...ownProps,
        ...stateProps,
        ...dispatchProps,
        onCopySurveySuccess: (data: any) => {
            dispatchProps.replaceSurveyListItem({
                position: 0,
                item: {
                    audience: {
                        ...data.audience,
                        finished: 0
                    },
                    clientName: data.clientName,
                    cost: data.cost,
                    isLoading: false,
                    isTemporary: false,
                    name: data.name,
                    slug: data.slug,
                    state: data.state,
                    surveyType: data.surveyType,
                    surveyScope: data.surveyScope,
                    paymentStatus: data.paymentStatus,
                    updatedAt: data.updatedAt
                }
            });
            dispatchProps.showNotification({
                type: 'info',
                timeOut: 5000,
                message: i18n.message.copied
            });
        }
    };
};

export default connect<StateProps, DispatchProps, OwnProps, MergedProps>(
    mapStateToProps,
    {
        archiveSurvey: archiveQuicksurvey,
        cancelSurveyModeration: cancelQuicksurveyModeration,
        pauseSurvey: pauseQuicksurvey,
        resumeSurvey: resumeQuicksurvey,
        scrollToTop,
        sendGoals,
        replaceSurveyListItem,
        showNotification,
        pushToSurveyList
    },
    mergeProps
)(Component);
